import type { NotificationBadgeProps } from './types'
/**
 * The notification count on the header bell (DESIGN.md "The Neutral Bad
 * State Rule"): a 16px inverse badge at 11px/600, never a colored dot.
 * Hidden at 0, capped at "{max}+". Decorative: the bell's accessible name
 * carries the count. Sits inside the button's own box (top 8px, right 6px).
 */

export function NotificationBadge({ count, max = 9 }: NotificationBadgeProps) {
  if (!Number.isFinite(count) || count <= 0) return null
  return (
    <span
      aria-hidden="true"
      className="absolute right-1.5 top-2 grid h-4 min-w-4 place-items-center bg-inverse px-1 text-[11px] font-semibold leading-none tracking-normal tabular-nums text-[color:var(--text-inverse)]"
    >
      {count > max ? `${max}+` : count}
    </span>
  )
}

export default NotificationBadge
